const es = {
  'successVerifyEmail.button.text': 'Let\'s go',
  'successVerifyEmail.button.noAuthenticated.text': 'Log in',
  'successVerifyEmail.title': 'Yeah! Your email has been verified!',
  'successVerifyEmail.text': 'Let’s continue to Social Piper!',
};

export default es;
